export class FacturaSeleccion {
    periodoCodigo: string;
    contratoCodigo: string;
    contratoVersion: string;
    version: string;
    firmarFactura: boolean;
    duplicado: boolean;
    waterMarkImageFilePath: string;
    facturaCodigo: string;
  }